module.exports = __webpack_public_path__ + "img/icon02.2271f3e4.png";